// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Overlay with Blur Effect */
.standard-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); 
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    -webkit-backdrop-filter: blur(8px);
            backdrop-filter: blur(8px); 
}

/* Modal Content */
.standard-modal-content {
    background-color: #fff;
    padding: 30px;
    border-radius: 15px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15); 
    max-width: 600px;
    width: 100%;
    box-sizing: border-box;
    animation: fadeIn 0.3s ease;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    transition: transform 0.3s ease;
}

/* Modal Header */
.standard-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    border-bottom: 1px solid #e0e0e0; 
    padding-bottom: 12px;
}

/* Modal Title */
.standard-modal-title {
    font-size: 1.8rem;
    font-weight: 600;
    color: #333;
    letter-spacing: 0.5px;
    margin: 0;
}

/* Close Button */
.standard-modal-close-btn {
    background: none;
    border: none;
    font-size: 1.8rem;
    cursor: pointer;
    color: #aaa;
    transition: color 0.3s;
}

.standard-modal-close-btn:hover {
    color: #000;
}

/* Standard Modal Body */
.standard-modal-body {
    font-size: 1.1rem;
    line-height: 1.6;
    color: #444;
    margin-bottom: 20px;
    padding: 15px;
    /* background-color: #f7f5f2; */
    background-color: #ece8e1;
    border-radius: 8px;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
    text-align: justify;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    transition: all 0.3s ease;
}

/* P Tag Styling */
.standard-modal-body p {
    margin: 0 0 1.2rem 0; 
    font-size: 1rem; 
    line-height: 1.6;
    /* color: #555;  */
    text-align: justify; 
}

/* Add hover effect for the modal body */
.standard-modal-body:hover {
    background-color: #f1f1f1;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}


/* Modal Footer */
.standard-modal-footer {
    display: flex;
    justify-content: flex-end;
    padding-top: 15px;
    border-top: 1px solid #e0e0e0;
}

/* Action Button - Matching staff-container button styling */
.standard-modal-action-btn {
    padding: 0.75rem;
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    border: none;
    border-radius: var(--radius);
    cursor: pointer;
    transition: var(--transition);
    font-size: 1rem;
}

.standard-modal-action-btn:hover {
    background-color: var(--clr-primary-4);
    box-shadow: var(--dark-shadow);
}

/* Animation for Modal Entrance */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: scale(0.9);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

/* Responsive Modal Styling */
@media (max-width: 768px) {
    .standard-modal-content {
        padding: 20px;
        max-width: 90%; 
    }

    .standard-modal-close-btn {
        font-size: 1.5rem; 
    }

    .standard-modal-action-btn {
        font-size: 0.9rem; 
        padding: 0.6rem; 
    }
}

@media (max-width: 480px) {
    .standard-modal-content {
        padding: 15px;
        max-width: 95%; 
    }

    .standard-modal-title {
        font-size: 1.4rem; 
    }

    .standard-modal-body {
        font-size: 1rem; 
    }

    .standard-modal-close-btn {
        font-size: 1.2rem; 
    }

    .standard-modal-action-btn {
        font-size: 0.85rem; 
        padding: 0.5rem; 
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Modals/standardModal.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kCAA0B;YAA1B,0BAA0B;AAC9B;;AAEA,kBAAkB;AAClB;IACI,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,2BAA2B;IAC3B,4DAA4D;IAC5D,+BAA+B;AACnC;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA,gBAAgB;AAChB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,SAAS;AACb;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA,wBAAwB;AACxB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,8CAA8C;IAC9C,mBAAmB;IACnB,4DAA4D;IAC5D,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,wCAAwC;AACxC;IACI,yBAAyB;IACzB,8CAA8C;AAClD;;;AAGA,iBAAiB;AACjB;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA,4DAA4D;AAC5D;IACI,gBAAgB;IAChB,sCAAsC;IACtC,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,sCAAsC;IACtC,8BAA8B;AAClC;;AAEA,iCAAiC;AACjC;IACI;QACI,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA,6BAA6B;AAC7B;IACI;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ","sourcesContent":["/* Modal Overlay with Blur Effect */\n.standard-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5); \n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    backdrop-filter: blur(8px); \n}\n\n/* Modal Content */\n.standard-modal-content {\n    background-color: #fff;\n    padding: 30px;\n    border-radius: 15px;\n    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15); \n    max-width: 600px;\n    width: 100%;\n    box-sizing: border-box;\n    animation: fadeIn 0.3s ease;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    transition: transform 0.3s ease;\n}\n\n/* Modal Header */\n.standard-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    border-bottom: 1px solid #e0e0e0; \n    padding-bottom: 12px;\n}\n\n/* Modal Title */\n.standard-modal-title {\n    font-size: 1.8rem;\n    font-weight: 600;\n    color: #333;\n    letter-spacing: 0.5px;\n    margin: 0;\n}\n\n/* Close Button */\n.standard-modal-close-btn {\n    background: none;\n    border: none;\n    font-size: 1.8rem;\n    cursor: pointer;\n    color: #aaa;\n    transition: color 0.3s;\n}\n\n.standard-modal-close-btn:hover {\n    color: #000;\n}\n\n/* Standard Modal Body */\n.standard-modal-body {\n    font-size: 1.1rem;\n    line-height: 1.6;\n    color: #444;\n    margin-bottom: 20px;\n    padding: 15px;\n    /* background-color: #f7f5f2; */\n    background-color: #ece8e1;\n    border-radius: 8px;\n    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);\n    text-align: justify;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    transition: all 0.3s ease;\n}\n\n/* P Tag Styling */\n.standard-modal-body p {\n    margin: 0 0 1.2rem 0; \n    font-size: 1rem; \n    line-height: 1.6;\n    /* color: #555;  */\n    text-align: justify; \n}\n\n/* Add hover effect for the modal body */\n.standard-modal-body:hover {\n    background-color: #f1f1f1;\n    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n\n/* Modal Footer */\n.standard-modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    padding-top: 15px;\n    border-top: 1px solid #e0e0e0;\n}\n\n/* Action Button - Matching staff-container button styling */\n.standard-modal-action-btn {\n    padding: 0.75rem;\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    border: none;\n    border-radius: var(--radius);\n    cursor: pointer;\n    transition: var(--transition);\n    font-size: 1rem;\n}\n\n.standard-modal-action-btn:hover {\n    background-color: var(--clr-primary-4);\n    box-shadow: var(--dark-shadow);\n}\n\n/* Animation for Modal Entrance */\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: scale(0.9);\n    }\n    to {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n/* Responsive Modal Styling */\n@media (max-width: 768px) {\n    .standard-modal-content {\n        padding: 20px;\n        max-width: 90%; \n    }\n\n    .standard-modal-close-btn {\n        font-size: 1.5rem; \n    }\n\n    .standard-modal-action-btn {\n        font-size: 0.9rem; \n        padding: 0.6rem; \n    }\n}\n\n@media (max-width: 480px) {\n    .standard-modal-content {\n        padding: 15px;\n        max-width: 95%; \n    }\n\n    .standard-modal-title {\n        font-size: 1.4rem; \n    }\n\n    .standard-modal-body {\n        font-size: 1rem; \n    }\n\n    .standard-modal-close-btn {\n        font-size: 1.2rem; \n    }\n\n    .standard-modal-action-btn {\n        font-size: 0.85rem; \n        padding: 0.5rem; \n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
